import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const InventoryLayout = ({ children, title, description, headerAction }) => {
  const location = useLocation();
  const pageTitle = title || 'Lager';
  const hasCustomDescription = description !== undefined;
  const pageDescription = hasCustomDescription ? description : 'Varelager, pluk og indkøbsordrer.';
  const tabs = [
    { path: '/lager/pluk', label: 'Pluk' },
    { path: '/indkoeb/ordrer', label: 'Salg' },
    { path: '/lager/varer', label: 'Varer' }
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div>
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">{pageTitle}</h1>
          {headerAction}
        </div>
        {pageDescription ? (
          <p className="text-gray-600 dark:text-gray-300 mt-1">{pageDescription}</p>
        ) : null}
      </div>

      <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
        <nav className="-mb-px flex space-x-6 sm:space-x-8">
          {tabs.map((tab) => (
            <Link
              key={tab.path}
              to={tab.path}
              className={`py-2 px-1 border-b-2 font-medium text-sm ${
                isActive(tab.path)
                  ? 'border-falck-blue text-falck-blue'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-200 dark:hover:text-gray-100'
              }`}
            >
              {tab.label}
            </Link>
          ))}
        </nav>
      </div>

      {children}
    </div>
  );
};

export default InventoryLayout;
